import { useCallback, useEffect, useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { fetchBase } from "../api/fetchBase";
import useAuth from "./useAuth";
import { axiosPrivate } from "../api/axios";

export const useQueryPrivate = (options, useQueryOptions = {}) => {
  const { getAuth } = useAuth();
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const [authEnabled, setAuthEnabled] = useState(isAuthenticated() && !authLoading);

  const { token } = getAuth();
  const { queryKey = options.url, headers = {}, ...requestOptions } = options;
  Object.assign(headers, { Authorization: `Bearer ${token}` });
  const {
    data,
    // error: queryError,
    ...useQueryResult
  } = useQuery({
    queryKey: [queryKey],
    queryFn: ({ signal }) =>
      fetchBase({ ...requestOptions, headers, signal }, axiosPrivate),
    ...useQueryOptions,
    // retry: false,
    retry: (failureCount, error) => {
      console.log({ failureCount, error });
      return failureCount < 3 ? true : false;
    },
    enabled: authEnabled && useQueryOptions?.enabled,
  });

  useEffect(() => {
    setAuthEnabled(isAuthenticated() && !authLoading);
  }, [isAuthenticated, authLoading]);

  // useEffect(() => {
  //   if (queryError) {
  //     data.error = { message: queryError.message || "Unknown Response Error" };
  //   }
  // }, [data, queryError]);

  return { ...useQueryResult, ...data };
};

export const useMutatePrivate = (options, useMutateOptions = {}) => {
  const { getAuth } = useAuth();
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const { token } = getAuth();
  const { headers = {} } = options;
  Object.assign(headers, { Authorization: `Bearer ${token}` });

  const mutation = useMutation({
    mutationFn: (args) =>
      fetchBase({ method: "post", ...options, ...args, headers }, axiosPrivate),
    ...useMutateOptions,
  });

  mutation.mutateOrigin = mutation.mutate;

  useEffect(() => {
    if (authLoading) {
      mutation.isLoading = true;
    }
  }, [authLoading, mutation]);

  mutation.mutate = useCallback(
    (data) => {
      if (!isAuthenticated() || authLoading) {
        return () => null;
      }
      return mutation.mutateOrigin(data);
    },
    [isAuthenticated, authLoading, mutation],
  );

  return mutation;
};
